import ReportDownloadContainer from '@app/components/reports/components/report-download-container';
import useGeneratePdf from '@app/components/reports/hooks/use-generate-pdf';
import { OperationReportTypeEnum } from '@shared/api/types';
import { useParams } from 'react-router-dom';
import { useSalesReportResult } from './sales-report-result-context';
import { useSalesReportSections } from './sales-report-sections';
import { useSalesFormattedReportSections } from './sales-report-utils';
import SalesReportIntro from './sections/sales-report-intro';

export default function SalesReportDownload() {
  const { report_uuid } = useParams();
  const { result, resultStatus } = useSalesReportResult();
  const { contentRef, status: downloadStatus } = useGeneratePdf(
    result ? result.title : undefined
  );

  const reportSections = useSalesReportSections(result, report_uuid!);
  const data = useSalesFormattedReportSections(reportSections, result);

  return (
    <ReportDownloadContainer
      contentRef={contentRef}
      status={resultStatus}
      sections={data}
      Intro={SalesReportIntro}
      reportType={OperationReportTypeEnum.sales}
      downloadStatus={downloadStatus}
    />
  );
}
